export const footerNavigationCategories = [
  {
    name: 'ABOUT THE MUSEUM',
    items: [
      {
        link: 'https://www.smm.org/about',
        name: 'About Us',
      },
      {
        link: 'https://www.smm.org/donations',
        name: 'Donations to Non-Profits',
      },
      {
        link: 'https://www.smm.org/media',
        name: 'Media Room',
      },
      {
        link: 'http://www.nps.gov/miss/planyourvisit/mrvcabou.htm',
        name: 'Mississippi River Visitor Center',
      },
      {
        link: 'https://www.smm.org/jobs',
        name: 'Careers',
      },
    ],
  },
  {
    name: 'FOR MUSEUM PROFESSIONALS',
    items: [
      {
        link: 'https://www.smm.org/exhibitservices',
        name: 'Exhibit Services',
      },
      {
        link: 'https://www.smm.org/exhibitrental',
        name: 'Exhibit Rental',
      },
      {
        link: 'https://www.smm.org/evaluation',
        name: 'Evaluation & Learning Research',
      },
    ],
  },
  {
    name: 'CONNECT WITH US',
    items: [
      {
        link: 'https://www.facebook.com/sciencemuseum',
        name: 'Facebook',
      },
      {
        link: 'https://twitter.com/sciencemuseummn',
        name: 'Twitter',
      },
      {
        link: 'https://instagram.com/sciencemuseummn',
        name: 'Instagram',
      },
      {
        link: 'https://www.linkedin.com/company/science-museum-of-minnesota/',
        name: 'Linkedin',
      },
      {
        link: 'https://www.pinterest.com/sciencemuseummn/',
        name: 'Pinterest',
      },
      {
        link: 'https://www.youtube.com/c/sciencemuseumofminnesota',
        name: 'YouTube',
      },
      {
        link: 'https://www.smm.org/subscribe',
        name: 'Newsletter',
      },
      {
        link: 'https://www.smm.org/contact',
        name: 'Contact Us',
      },
    ],
  },
];

export const pathPrefixMap = {
  ContentfulArticle: '/learn/',
};

export const displayNameLimits = {
  headerDropdownTitle: 16,
  headerStaticTitle: 16,
  headerLinkName: 30,
  footerSectionTitle: 28,
  footerLinkName: 36,
  breadcrumbsLink: 24,
};

export const footerPremierPartners = [
  {
    name: 'threeM',
    ariaLabel: 'Learn more about our Premier Partner, the 3M Company',
    link: 'https://www.3m.com/',
  },
  {
    name: 'healthPartners',
    ariaLabel: 'Learn more about our Premier Partner, Health Partners, Inc.',
    link: 'https://www.healthpartners.com/',
  },
  {
    name: 'target',
    ariaLabel: 'Learn more about our Premier Partner, the Target Corporation',
    link: 'https://www.target.com/',
  },
  {
    name: 'midwestDairy',
    ariaLabel: 'Learn more about our Premier Partner, Midwest Dairy.',
    link: 'https://www.midwestdairy.com/',
  },
];

const currentYearString = new Date().getFullYear();

export const footerMailingAddress = [
  {
    name: `© ${currentYearString} Science Museum of Minnesota`,
    type: 'text',
  },
  {
    name: '120 W. Kellogg Blvd.',
    type: 'text',
  },
  {
    name: 'Saint Paul, MN 55102',
    type: 'text',
  },
  {
    name: '(651) 221-9444',
    type: 'text',
  },
  {
    name: 'info@smm.org',
    link: 'mailto:info@smm.org',
    type: 'link',
  },
];

export const footerLegalLinks = [
  {
    name: 'Privacy Policy',
    link: 'https://www.smm.org/privacy',
    type: 'link',
  },
  {
    name: 'Legal Notice',
    link: 'https://www.smm.org/legal',
    type: 'link',
  },
];

export const dropDownNavigationCategories = [
  {
    name: 'VISIT',
    items: [
      {
        link: 'https://www.smm.org/exhibits',
        name: 'Exhibits',
        source: 'external',
      },
      {
        link: '/us',
        name: 'NEW Experiences',
        source: 'internal',
      },
      {
        link: 'https://www.smm.org/tickets',
        name: 'Hours & Admission',
        source: 'external',
      },
      {
        link: 'https://smm.org/visit/parking-directions',
        name: 'Parking & Directions',
        source: 'external',
      },
      {
        link: '/food-drink',
        name: 'Food & Drink',
        source: 'internal',
      },
      {
        link: 'https://smm.org/visit/accessibility-amenities',
        name: 'Accessibility & Amenities',
        source: 'external',
      },
      {
        link: 'https://smm.org/visit/private-events',
        name: 'Private Events',
        source: 'external',
      },
    ],
  },
  {
    name: 'EDUCATION',
    items: [
      {
        link: '/educators',
        name: 'Educators',
        source: 'internal',
      },
      {
        link: '/learn',
        name: 'Learn from Home',
        source: 'internal',
      },
      {
        link: 'https://smm.org/ideal-center',
        name: 'Professional Development',
        source: 'external',
      },
    ],
  },
  {
    name: 'SCIENCE',
    items: [
      {
        link: 'https://www.smm.org/scientists',
        name: 'Scientists',
        source: 'external',
      },
      {
        link: 'https://smm.org/collections',
        name: 'Collections',
        source: 'external',
      },
      {
        link: 'https://www.smm.org/scwrs',
        name: 'Research Station',
        source: 'external',
      },
      {
        link: '/evolution',
        name: 'Statement on Evolution',
        source: 'internal',
      },
      {
        link: '/climate-change',
        name: 'Statement on Climate Change',
        source: 'internal',
      },
    ],
  },
  {
    name: 'EQUITY',
    items: [
      {
        link: '/us',
        name: 'Science is All of Us',
        source: 'internal',
      },
      {
        link: 'https://smm.org/ideal-center',
        name: 'Professional Development',
        source: 'external',
      },
      {
        link: 'https://smm.org/kaysc',
        name: 'Youth STEM Justice',
        source: 'external',
      },
      {
        link: '/equity',
        name: 'Statement on Equity & Inclusion',
        source: 'internal',
      },
      {
        link: '/museum-voices',
        name: 'Museum Voices',
        source: 'internal',
      },
    ],
  },
  {
    name: 'JOIN & GIVE',
    items: [
      {
        link: '/membership',
        name: 'Become A Member',
        source: 'internal',
      },
      {
        link: 'https://www.smm.org/give',
        name: 'Give',
        source: 'external',
      },
      {
        link: '/support/corporate-support',
        name: 'Corporate Support',
        source: 'internal',
      },
      {
        link: 'https://smm.org/support/legacy-giving',
        name: 'Legacy Giving',
        source: 'external',
      },
    ],
  },
];

export const staticNavigationCategories = [
  {
    link: '/membership',
    name: 'Membership',
    source: 'internal',
    color: 'dark-blue',
  },
  {
    link: 'https://my.smm.org/events',
    name: 'Tickets',
    source: 'external',
    color: 'blue',
  },
  {
    link: 'https://www.smm.org/give',
    name: 'Give',
    source: 'external',
    color: 'mid-gray',
  },
  {
    link: 'https://store.smm.org/',
    name: 'Store',
    source: 'external',
    color: 'green',
  },
];

export const staticLinkColor = [
  'dark-blue',
  'blue',
  'mid-gray',
  'green',
  'mid-blue',
  'dark-green',
];
